import React from 'react';
import PropTypes from 'prop-types';
import './styles.css';

const BasicLabel = React.memo(props => (
  <label className="basic-label" htmlFor={props.name} style={props.styles}>
    <span
      className={
        props.required
          ? 'basic-label-text basic-label-text--required'
          : 'basic-label-text'
      }
    >
      {props.text}
    </span>
  </label>
));

BasicLabel.propTypes = {
  name: PropTypes.string,
  required: PropTypes.bool,
  text: PropTypes.string.isRequired,
  styles: PropTypes.object,
};

export default BasicLabel;
